import React from "react";
import "./HomeWhyChooseUs.css";

export default function HomeWhyChooseUs({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH CONTENT =================
  const contentEN = {
    smallTitle: "OUR DIFFERENCE",
    title: "WHY LEADING BUSINESSES <br /> CHOOSE PESTEL & PARTNERS",
    description:
      "In a marketplace defined by complexity, organizations choose Pestel & Partners for our ability to turn financial insight into an actionable strategy. We combine technical expertise, regulatory precision, and industry foresight to help clients build confidence in every decision. From auditing financial statements to structuring cross-border transactions, our professionals bring clarity, innovation, and measurable value to every engagement. With a presence across emerging markets, we don’t just advise — we empower businesses to grow responsibly and sustainably.",
    values: [
      { icon: "assets/icons/Excellence.png", text: "Integrity" },
      { icon: "assets/icons/Partnership.png", text: "Insight" },
      { icon: "assets/icons/Innovation.png", text: "Innovation" },
      { icon: "assets/icons/Growth.png", text: "Impact" },
    ],
  };

  // ================= FRENCH CONTENT =================
  const contentFR = {
    smallTitle: "NOTRE DIFFÉRENCE",
    title: "POURQUOI LES ENTREPRISES LEADERS <br /> CHOISISSENT PESTEL & PARTNERS",
    description:
      "Dans un environnement économique marqué par la complexité, les organisations choisissent Pestel & Partners pour notre capacité à transformer l’expertise financière en stratégies concrètes. Nous combinons expertise technique, rigueur réglementaire et vision sectorielle afin d’aider nos clients à prendre des décisions en toute confiance. De l’audit des états financiers à la structuration de transactions transfrontalières, nos équipes apportent clarté, innovation et valeur mesurable à chaque mission. Présents sur les marchés émergents, nous ne faisons pas que conseiller — nous accompagnons une croissance responsable et durable.",
    values: [
      { icon: "assets/icons/Excellence.png", text: "Intégrité" },
      { icon: "assets/icons/Partnership.png", text: "Vision" },
      { icon: "assets/icons/Innovation.png", text: "Innovation" },
      { icon: "assets/icons/Growth.png", text: "Impact" },
    ],
  };

  // ================= SELECT CONTENT =================
  const content = isFrench ? contentFR : contentEN;

  return (
    <section className="why-wrapper section">
      <div className="row align-items-center homewhychoosemob">

        {/* LEFT IMAGES */}
        <div className="col-12 col-lg-6 position-relative mb-4 mb-lg-0">
          <div className="images-container">
            <img
              src="assets/images/WhyChooseImg2.png"
              alt="Business Person"
              className="img-fluid why-img1"
            />

            <img
              src="assets/images/WhyChooseImg1.png"
              alt="Team Meeting"
              className="img-fluid why-img2"
            />
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="col-12 col-lg-6">
          {/* Small heading */}
          <div className="d-flex align-items-center mb-3">
            <div className="why-line"></div>
            <h6 className="ms-3 choose-us-text mb-0">
              {content.smallTitle}
            </h6>
          </div>

          <h2
            className="why-title mb-3"
            dangerouslySetInnerHTML={{ __html: content.title }}
          />

          <p className="why-description mb-4">
            {content.description}
          </p>

          {/* ICON ROW */}
          <div className="row icon-row g-3">
            {content.values.map((item, index) => (
              <div key={index} className="col-5 d-flex align-items-center">
                <img src={item.icon} className="icon" alt={item.text} />
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Background Logo */}
      <div className="bg-logo"></div>
    </section>
  );
}
